import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const savedUser = localStorage.getItem("userInfo");
    const savedTenant = localStorage.getItem("selectedTenant");

    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      if (savedTenant) setSelectedTenant(JSON.parse(savedTenant));
    }
    setLoading(false);
  }, []);

  const login = (apiResponse) => {
    const data = apiResponse?.data;
    if (!data) return;

    const {
      username,
      full_name: fullName,
      tenant_name: tenantName,
      logo,
      access_token: accessToken,
      refresh_token: refreshToken,
      applications = [],
    } = data;

    const tenantLogo = logo ? `data:image/png;base64,${logo}` : null;

    const formattedUser = {
      username,
      fullName,
      tenantName,
      tenantLogo,
      accessToken,
      refreshToken,
      applications,
    };

    setUser(formattedUser);
    localStorage.setItem("userInfo", JSON.stringify(formattedUser));
    if (accessToken) localStorage.setItem("accessToken", accessToken);
    if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  const selectTenant = (tenant) => {
    if (!tenant) {
      setSelectedTenant(null);
      localStorage.removeItem("selectedTenant");
      return;
    }
    const secret = tenant.publicKey || tenant.secretKey || null;
    const normalized = { ...tenant, publicKey: secret, secretKey: secret };
    setSelectedTenant(normalized);
    localStorage.setItem("selectedTenant", JSON.stringify(normalized));
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        isAuthenticated,
        loading,
        selectedTenant,
        selectTenant,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
